import React  from 'react';
import Popup from '../popups/popup';
import I18n from "lib/i18n/i18n";
import { connect } from "react-redux";
import UserActions from "lib/userActions";
import {abortItem, getUserBundles} from 'actions/myAccount';
import {SmallLinkButton, SmallPrimaryButton} from "@worthy-npm/clarity";
import {bindActionCreators} from "redux";
import {isMobile} from 'helpers/ApplicationHelper';


class PopupSubmitItemCancellation extends Popup {
    constructor(props) {
        super(props);
        this._hide = this._hide.bind(this);
        this.submitCancellationClicked = this.submitCancellationClicked.bind(this);
    }

    static initPopup(props = {}) {
        props.stopAnimation ? props.stopAnimation() : null;
        Popup.initPopup.call(this, props);
    }

    title() {
        return I18n.getString('cancelSubmissionOnline::popupTitle');

    }


_onPopupClose() {
        if (this.props.stopAnimation) {
            this.props.stopAnimation();
        }
    }

    submitCancellationClicked() {
        this.props.abortItem(this.props.itemPublicId).then((res)=>{
            let data = res.payload.data;
            if (data.status === 'done') {
                const event = ' ';
                UserActions.myAccount(event, this.props.itemPublicId, 'Item');
                this.props.rerenderParentCallback();
            }
            else {
                console.log(res.status);
                alert('oops!...something went wrong');
            }
        }).catch((err)=>
        {
            console.log(err);
            alert('oops...something went wrong');
        }).finally(()=> this._hide());

    }

    _hide() {
        super._hide();
    }

    content() {
        return (
            <div className={'schedule-shipment-custom-popup'}>
                <p className={'cancel-item-text'}> {I18n.getString('cancelSubmissionOnline::popupContent')}</p>
                <div className="control-buttons-row">
                    <div className={'go-back-btn-wrapper'}>
                        <SmallPrimaryButton  overrideCSS={{'font-size': '16px'}} click={this._hide} text={I18n.getString('cancelSubmissionOnline::btnGoBack')} />
                    </div>
                   <div className={'confirm-btn-wrapper'}>
                       <SmallLinkButton overrideCSS={{fontSize: `${isMobile() ? '4.3vmin' : '16px'}`}} click={() => {this.submitCancellationClicked();
                       }} text={I18n.getString('cancelSubmissionOnline::btnConfirm')}/>

                   </div>

                </div>

            </div>

        );
    }
}

PopupSubmitItemCancellation.defaultProps = {
    popupClassName: 'popup-schedule-secure-shipment cancel-item',
    single: true,
    modal: true,
    onPopupClose: function() {
        this._onPopupClose();
    }
};

const mapStateToProps = ({ Item, ADO, Experiments, Personalized, Session, MyAccount }) => {
    return {
        item: Item,
        ADO,
        experiments: Experiments,
        P13N: Personalized,
        Session,
        MyAccount
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        abortItem,
        getUserBundles
    }, dispatch);
};




export default connect(mapStateToProps, mapDispatchToProps)(PopupSubmitItemCancellation);
